import { en } from "./en"

// export tranlations
export const translations = {
  en
}
